/** Growmark Color Palette - Defines color values for both light and dark themes. */
export const GrowmarkColorPalette = {
  /** Unbranded customers are represented using a distinct red color. */
  Unbranded: {
    /** Light Mode - Crimson */ 
    Light: "#D61C38",
    /** Dark Mode - Ruby Red */ 
    Dark: "#E32643",
  },

  //----------------------------------------------------------------------------------
  // Core Palette - Essential colors used for backgrounds, text, and outlines.
  //----------------------------------------------------------------------------------

  /** Pure white and off-white for backgrounds and surfaces. */
  White: {
    /** Light Mode - Pure White */ 
    Light: "#FFFFFF",
    /** Dark Mode - White Smoke */ 
    Dark: "#F5F5F5",
  },

  /** Used for primary text and outlines. */
  Black: {
    /** Light Mode - Jet Black */ 
    Light: "#333333",
    /** Dark Mode - Pure Black */ 
    Dark: "#1A1A1A",
  },

  /** Secondary color for subtle UI elements and borders. */
  Gray: {
    /** Light Mode - Slate Gray */ 
    Light: "#6C757D",
    /** Dark Mode - French Gray */ 
    Dark: "#ADB5BD",
  },

  /** Primary myGMK brand color used for interactive elements. */
  Blue: {
    /** Light Mode - Azure */ 
    Light: "#007BFF",
    /** Dark Mode - Sky Blue */ 
    Dark: "#1E88E5",
  },

  //----------------------------------------------------------------------------------
  // Auxiliary Palette - Colors used to indicate various statuses and actions
  //----------------------------------------------------------------------------------

  /** Indicates success or healthy status items. */
  Green: {
    /** Light Mode - Emerald */ 
    Light: "#2ECC71",
    /** Dark Mode - Jade */ 
    Dark: "#33B249",
  },

  /** Used for errors, alerts, or failures. */
  Red: {
    /** Light Mode - Imperial Red */ 
    Light: "#FF0033",
    /** Dark Mode - Vermilion */ 
    Dark: "#E53935",
  },

  /** Represents warnings or clearable items. */
  Orange: {
    /** Light Mode - Tangerine */ 
    Light: "#FF851B",
    /** Dark Mode - Amber */ 
    Dark: "#FF9800",
  },

  /** Used for optional selections or statuses. */
  Purple: {
    /** Light Mode - Amethyst */ 
    Light: "#9B51E0",
    /** Dark Mode - Lavender */ 
    Dark: "#A56CC1",
  },

  LightGrey:{
    /** Light Mode - Light Grey */ 
    Light: "#EEEEEE",
    /** Dark Mode - Dark Grey */ 
    Dark: "#515151",
  },

  NavBarLightGrey: {
    /** Light Mode - Light Grey */ 
    Light: "#f5f5f5",
    /** Dark Mode - Dark Grey */ 
    Dark: "#262626",
  }
 
} as const;